import React, { useEffect } from 'react';
import './index.scss';
import {
  Box,
  Button,
  Checkbox,
  Flex,
  Image,
  Link,
  Stack,
  Text,
} from '@chakra-ui/react';
import { useState } from 'react';
import { getPrivacyUrl } from '../../component/json';
import { linkUtils } from '../../utils/linkUtils';
import logo_kokoka from '../../assets/images/logo_kokoka.svg'

const Agree = () => {
  //assets
  const system_words: any = {};
  system_words['ja'] = require('../../assets/jsons/lang/ja.json');
  system_words['en'] = require('../../assets/jsons/lang/en.json');
  system_words['vn'] = require('../../assets/jsons/lang/vn.json');
  system_words['ch'] = require('../../assets/jsons/lang/ch.json');
  //states
  const [termsChecked, setTermsChecked] = useState<boolean>(false);
  const [policyChecked, setPolicyChecked] = useState<boolean>(false);
  const [selectedLang, setSelectedLang] = useState<string>('ja');

  //functions
  const onStart = () => {
    window.location.replace(`/start`);
    //同意したかどうかを格納する
    localStorage.setItem('agreed', 'true');
  };

  useEffect(() => {
    if (localStorage.hasOwnProperty('systemLanguage')) {
      setSelectedLang(String(localStorage.getItem('systemLanguage')))
    }
  }, []);

  return (
    <Stack
      id="bg-image"
      pb="5px"
      m="auto"
      w="375px"
      h="100vh"
      bgSize="cover"
      boxSizing="content-box"
      bgColor="white"
      spacing="24px"
      align="center"
      pt="250px"
      justify="flex-start"
    >
      <Image
        src={logo_kokoka}
        w={{ base: "220px", md: "220px", lg: "290px" }}
        h={{ base: "80px", md: "80px", lg: "110px" }}
      />
      <Text fontSize="16px" textAlign="center" px="50px">
        {system_words[selectedLang]['KT_0002_01']}
      </Text>
      <Flex justify="center" wrap="wrap" px="10px" gap="10px">
        <Checkbox size="lg" isRequired onChange={(e) => setTermsChecked(e.target.checked)} />
        {/* 利用規約 */}
        <Link
          href={linkUtils.getTermsLink()}
          target="_blank"
          color="orange"
          fontWeight="bold"
          fontSize="13px"
          alignSelf="center"
          ml="5px"
        >
          {system_words[selectedLang]['KT_0002_02']}
        </Link>
        <Checkbox size="lg" isRequired onChange={(e) => setPolicyChecked(e.target.checked)} />
        {/* プライバシーポリシー */}
        <Link
          href={String(getPrivacyUrl())}
          target="_blank"
          color="orange"
          fontWeight="bold"
          fontSize="13px"
          alignSelf="center"
          ml="5px"
        >
          {system_words[selectedLang]['KT_0002_03']}
        </Link>
      </Flex>
      <Button
        id="start_btn"
        className="btn-border"
        onClick={onStart}
        textColor="white"
        bgColor="orange"
        w="200px"
        disabled={!(termsChecked && policyChecked)}
      >
        {system_words[selectedLang]['KT_0002_04']}
      </Button>
      <Text fontSize="sm" pt="50px" pb="20px" textAlign="center">
        Copyright ©SUN Co.,Ltd All Rights Reserved
      </Text>
    </Stack>
  );
};

export default Agree;
